import { VERSION } from '../config';
import {
    decrypt,
    encrypt
} from '../utils';
import firebaseService from './firebase';
import { storage } from './localstorage';

export const FIRST_AID_KIT_PROFILE_KEY = 'firstAidKit';
export const FIRST_AID_KIT_KEY = 'firstAidKitStorage';

export const FIRST_AID_KIT_SYNC_KEY = 'syncedVersionFirstAidKit';

const toLog = (...args) => {
    //console.log(`DRUGS:${args.length > 1 ? ` ${args?.[0]}` : ''}`, ...(args?.length > 1 ? args.slice(1) : args));
};

export const prepareFirstAidKitDataForSave = ({
    hashKey,
    basket = [],
    drugSearch = [],
}) => {
    return (
        encrypt(
            {
                basket,
                drugSearch,
            },
            hashKey,
        ) || ''
    );
};

export const saveFirstAidKit = async ({
    profileId,
    basket,
    drugSearch,
    hashKey,
}) => {
    try {

        const allData = (await storage.getObject(FIRST_AID_KIT_KEY, {})) ?? {};
        const data = prepareFirstAidKitDataForSave({
            hashKey,
            basket,
            drugSearch,
        });
        allData[profileId] = data;
        await storage.set(FIRST_AID_KIT_KEY, allData);
        toLog('saveFirstAidKit', {
            basket,
            drugSearch,
            profileId,
            hashKey,
            data,
            allData,
        });
    } catch (error) {
        toLog('saveFirstAidKit: error saving first aid kit', error);
        throw error;
    }
};

export const getFirstAidKitFromFB = async ({
    hashKey,
    storeKey,
}) => {
    const profileData = await firebaseService.getById('profile', storeKey);
    const encodedPrefs = profileData?.prefs ?? '';
    const prefs = decrypt(encodedPrefs, hashKey) ?? {};
    const basket = prefs?.basket ?? [];
    const drugSearch = prefs?.drugSearch ?? [];
    toLog('getFirstAidKitFromFB', {
        basket,
        drugSearch,
    });
    return {
        basket,
        drugSearch,
    };
};

export const getFirstAidKitFromStorage = async ({
    profileId,
    hashKey,
}) => {
    const allData = (await storage.get(FIRST_AID_KIT_KEY))?.[profileId] || {};
    const decodedData = decrypt(allData, hashKey) || {};
    toLog('getFirstAidKitFromStorage', {
        decodedData,
        profileId,
        allData,
        hashKey,
    });
    return {
        basket: decodedData?.basket || [],
        drugSearch: decodedData?.drugSearch || [],
    };
};

export const isSyncedFirstAidKit = async () => {
    const result = await storage.get(FIRST_AID_KIT_SYNC_KEY);
    const ver = VERSION?.split('.')
        .slice(0, 3)
        .join('.');
    await storage.set(FIRST_AID_KIT_SYNC_KEY, ver);
    return result;
};

export const getFirstAidKit = async ({
    hashKey,
    storeKey,
    me: { profileId } = {},
}) => {
    const syncedVersion = await isSyncedFirstAidKit();
    let data = {};
    if (typeof syncedVersion === 'string' && syncedVersion !== 'undefined') {
        data = await getFirstAidKitFromStorage({
            profileId,
            hashKey,
        });
        toLog('getFirstAidKit: fetched from storage', data);
    } else {
        data = await getFirstAidKitFromFB({
            hashKey,
            storeKey,
        });
        toLog('getFirstAidKit: fetched from firebase', data);
        try {
            if (data?.basket?.length || data?.drugSearch?.length) {
                await saveFirstAidKit({
                    profileId,
                    basket: data?.basket || [],
                    drugSearch: data?.drugSearch || [],
                    hashKey,
                });
            }
        } catch (e) {
            toLog('handleFirstAidKit: error fetching first aid kit from firebase', e);
        }
    }
    const basket = data?.basket || [];
    const drugSearch = data?.drugSearch || [];

    return {
        basket,
        drugSearch,
    };
};

export const handleFirstAidKit = async (params) => {
    const {
        me: { profileId } = {},
        hashKey,
        storeKey,
    } = params;
    if (!profileId || !hashKey || !storeKey) {
        toLog('handleFirstAidKit: no profileId, hashKey or storeKey', {
            profileId,
            hashKey,
            storeKey,
            params,
        });
        return;
    }

    const data = await getFirstAidKit(params);
    toLog('handleFirstAidKit', {
        profileId,
        hashKey,
        storeKey,
        data,
    });
};
